import React from 'react';
import { Checkbox as BaseUICheckbox, CheckboxProps } from 'baseui/checkbox';

import { TechemTheme } from '@techem/techem-theme';

interface CustomCheckboxProps extends CheckboxProps {
  additionalTestId?: string;
  topLevelStylingOverrides?: any;
}

const Checkbox = (props: CustomCheckboxProps) => {
  return (
    <BaseUICheckbox
      {...props}
      overrides={{
        Label: {
          style: { color: TechemTheme.colors.contentSecondary }
        },
        Root: {
          style: { ...props.topLevelStylingOverrides },
          props: {
            'data-gi': `checkbox-item${
              props.additionalTestId !== undefined ? ' ' + props.additionalTestId : ''
            }`
          }
        },
        Checkmark: {
          style: ({ $checked }) => ({
            height: '22px',
            width: '22px',
            backgroundSize: 'auto',
            backgroundColor: $checked
              ? TechemTheme.colors.tickFillSelected
              : TechemTheme.colors.backgroundSecondary,
            borderTopWidth: '1.5px',
            borderBottomWidth: '1.5px',
            borderLeftWidth: '1.5px',
            borderRightWidth: '1.5px',
            borderTopLeftRadius: '6px',
            borderTopRightRadius: '6px',
            borderBottomLeftRadius: '6px',
            borderBottomRightRadius: '6px'
          }),
          props: {
            'data-gi': 'checkbox'
          }
        }
      }}
    >
      {props.children}
    </BaseUICheckbox>
  );
};
export default Checkbox;
